/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loading from "../../../components/shared/loading/Loading";
import { deleteData } from "../../../hooks/delete";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";
import HiringPartnersContent from "./HiringPartnersContent";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { motion } from "framer-motion";

const HiringPartnersContentPage = ({ apiId }) => {
  const { homeApi } = apiPath;
  const { homePartnersAdd, homePartners } = RoutePath;
  const { clientHome } = clientSideUrl;

  const [homeSubsidariesData, homeSubsidariesLoading] = useFetch(homeApi);
  const [partnersList, setPartnersList] = useState([]);
  const [updatedList, setUpdatedList] = useState(null);

  useEffect(() => {
    const hiringPartners = homeSubsidariesData
      ?.find(item => item.section_type === "hiring-partners")?.banner_images || [];

    setPartnersList(hiringPartners);
  }, [homeSubsidariesData]);

  async function handleSingleDelete(id) {
    const parentId = homeSubsidariesData?.find(item =>
      item.banner_images.some(img => img._id === id)
    )?._id;

    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(homeApi, parentId, { id });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?.matchedCount > 0;
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newOrder = arrayMoveImmutable(partnersList, oldIndex, newIndex);
    setPartnersList(newOrder);
    setUpdatedList(newOrder);
  };

  const updateNewListToDB = () => {
    updateData("reorder/hiring-partners", updatedList, apiId); // Adjust endpoint if needed
    setTimeout(() => {
      setUpdatedList(null);
      window.location.href = "/" + homePartners;
    }, 800);
  };

  const DragHandle = SortableHandle(() => (
    <span className="cursor-move text-gray-400">⠿</span>
  ));

  const SortableItem = SortableElement(({ item, onDelete }) => (
    <HiringPartnersContent
      key={item._id}
      businessSubsData={item}
      handleSingleDelete={onDelete}
      dragHandle={<DragHandle />}
      apiId={apiId}
    />
  ));

  const SortableList = SortableContainer(({ items, onDelete }) => (
    <div>
      {items.map((item, index) => (
        <SortableItem key={`partner-${item._id}`} index={index} item={item} onDelete={onDelete} />
      ))}
    </div>
  ));

  if (homeSubsidariesLoading) {
    return <Loading />;
  }

  return (
    <div className="relative">
      <div className="mb-4 w-full text-right font-semibold text-sm mt-10 ">
        <div>

        </div>
        <div className="flex justify-end items-center gap-4">
          {updatedList && (
            <motion.button
              onClick={updateNewListToDB}
              type="button"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="btn border-2 text-[#DB0029] font-bold border-[#DB0029] hover:text-white hover:bg-[#DB0029] px-3 py-1.5 rounded-xl"
            >
              Save Changes
            </motion.button>
          )}

          <Link className="text-black hover:text-[#DB0029]" to={clientHome} target="_blank">
            Visit page
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="inline w-4 h-4 ml-1 align-text-top"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                />
              </svg>
            </span>
          </Link>
        </div>
      </div>

      <div className=" border-t pt-5 mt-5">
        <SortableList items={partnersList} onDelete={handleSingleDelete} onSortEnd={onSortEnd} axis="y" useDragHandle />
      </div>

      <div className="fixed bottom-10 right-7 md:right-14">
        <Link to={`/${homePartnersAdd}`}>
          <button
            title="Add new partner"
            className="p-4 md:p-5 bg-white text-black border-2 border-black rounded-full hover:border-[#DB0029] hover:text-[#DB0029] transition-all duration-100"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 md:w-8 md:h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default HiringPartnersContentPage;
